import { lazy } from "react";

const omcLogin = lazy(() => import("./omcLogin"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const ResetPassword = lazy(() => import("./ResetPassword"));
const EmailVerifiedCheck = lazy(() => import("./EmailVerifiedCheck"));
const Error404 = lazy(() => import("./Error"));

const sessionsRoutes = [
  {
    path: "/session/signin",
    component: omcLogin,
  },
  {
    path: "/verifyemail/:eId",
    component: EmailVerifiedCheck,
  },
  {
    path: "/session/forgot-password",
    component: ForgotPassword,
  },
  {
    path: "/reset-password/:id",
    component: ResetPassword,
  },
  {
    path: "/session/404",
    component: Error404,
  },
];

export default sessionsRoutes;
